import clsx from 'clsx'
import { Icon } from 'components/ui/Icon'
import { useToggleWidget } from 'hooks/useToggleWidget'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { useGetSetting } from 'api/settings'

export const WidgetHelpMessage = () => {
  const isWidgetOpened = useToggleWidget()
  const { t } = useTranslation()
  const { setting } = useGetSetting()
  const [showHelpMessage, setShowHelpMessage] = useState(false)
  const hasShownRef = useRef(false)

  useEffect(() => {
    if (hasShownRef.current) return
    const timer = setTimeout(() => {
      if (!isWidgetOpened && setting?.portal?.helpPopupVisible !== false) {
        setShowHelpMessage(true)
        hasShownRef.current = true
      }
    }, 1500)
    return () => clearTimeout(timer)
  }, [setting, isWidgetOpened])

  useEffect(() => {
    if (isWidgetOpened && showHelpMessage) {
      setShowHelpMessage(false)
    }
  }, [isWidgetOpened, showHelpMessage])

  if (showHelpMessage) {
    return (
      <div
        className={clsx(
          'animate-slide-up-bounce tw-fixed tw-bottom-20 tw-right-4 tw-text-sm tw-border-primary-500 tw-border tw-p-2 tw-rounded-xl tw-bg-surface',
        )}
      >
        <div style={{ zIndex: 999999, fontWeight: 700, color: setting?.primaryColor }}>
          <span className={'tw-mr-[3px]'}>{t('needHelp')}</span>
          <Icon icon={['fas', 'question-circle']} style={{ fontSize: '14px' }} color={setting?.primaryColor} />
        </div>
      </div>
    )
  }

  return null
}
